import { action } from 'satcheljs/lib/legacy';
export default action('setIsSearching')(function setIsSearching(viewState, isSearching, queryString) {
    viewState.isSearching = isSearching;
    if (queryString != null) {
        viewState.queryString = queryString;
    }
});
//# sourceMappingURL=setIsSearching.js.map